export default __webpack_public_path__ + "0c565796d0d159027b4fe4fbb2aed0e4.png";